import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLang, catLabel } from "../lib/i18n";
import { LangToggle } from "../components/LangToggle";
import { StatusBadge } from "../components/StatusBadge";
import { HardHat, LogOut, MapPin, ChevronRight, Inbox, Clock } from "lucide-react";

export default function TechDashboard() {
  const { t, lang } = useLang();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [orders, setOrders] = useState(null);

  useEffect(() => { api.get("/tech/orders").then((r) => setOrders(r.data)).catch(() => setOrders([])); }, []);

  return (
    <div className="mx-auto min-h-screen max-w-md bg-slate-50 pb-8">
      <header className="sticky top-0 z-30 flex items-center justify-between border-b border-slate-200 bg-slate-900 px-4 py-3 text-white">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-500"><HardHat className="h-4 w-4" /></div>
          <div><p className="font-display text-sm font-extrabold leading-none">{t("tech_area")}</p><p className="text-xs text-slate-400">{user?.name}</p></div>
        </div>
        <div className="flex items-center gap-2"><LangToggle /><button data-testid="logout-btn" onClick={() => logout().then(() => nav("/login"))} className="rounded-full bg-slate-800 p-2"><LogOut className="h-4 w-4" /></button></div>
      </header>

      <div className="p-4">
        <h2 className="font-display text-xl font-extrabold text-slate-900">{t("assigned_jobs")}</h2>
        <div className="mt-4 space-y-3">
          {orders === null && <p className="text-center text-sm text-slate-400">{t("loading")}</p>}
          {orders?.length === 0 && <div className="mt-16 flex flex-col items-center gap-2 text-slate-400"><Inbox className="h-12 w-12" /><p className="text-sm font-semibold">{t("no_jobs")}</p></div>}
          {orders?.map((o) => (
            <button key={o.id} data-testid={`tech-order-${o.id}`} onClick={() => nav(`/ordine/${o.id}`)}
              className="card-hover flex w-full items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 text-left">
              <div className="flex-1">
                <div className="flex items-center gap-2"><span className="font-mono text-xs font-bold text-blue-600">{o.code}</span>{o.is_demo && <span className="rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold text-slate-500">DEMO</span>}</div>
                <p className="mt-0.5 text-sm font-bold text-slate-900">{o.problem}</p>
                <p className="flex items-center gap-1 text-xs text-slate-500"><MapPin className="h-3 w-3" />{o.address?.street}, {o.address?.city}</p>
                {o.time_slot && <p className="flex items-center gap-1 text-xs text-slate-400"><Clock className="h-3 w-3" />{o.time_slot}</p>}
                <div className="mt-2 flex items-center gap-2"><StatusBadge status={o.status} /></div>
              </div>
              <ChevronRight className="h-5 w-5 text-slate-300" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
